import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { FileUploadOutlined } from '@mui/icons-material';

export const ExportButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<FileUploadOutlined />} {...props}>
      {children ?? t('Export')}
    </Button>
  );
};
